"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.businessData = businessData;
exports.chartBuyApi = chartBuyApi;
exports.chartOrder30Api = chartOrder30Api;
exports.chartOrderMonthApi = chartOrderMonthApi;
exports.chartOrderWeekApi = chartOrderWeekApi;
exports.chartOrderYearApi = chartOrderYearApi;
exports.chartUserApi = chartUserApi;
exports.collectDataApi = collectDataApi;
exports.getActiveUserDataApi = getActiveUserDataApi;
exports.getBoughtUserDataApi = getBoughtUserDataApi;
exports.getNewMemberDataApi = getNewMemberDataApi;
exports.getNewUserDataApi = getNewUserDataApi;
exports.getOrderLineDataApi = getOrderLineDataApi;
exports.getOrderStatisticsDataApi = getOrderStatisticsDataApi;
exports.getOrderTypePieDataApi = getOrderTypePieDataApi;
exports.getProductCategoryPieDataApi = getProductCategoryPieDataApi;
exports.getProductLineDataApi = getProductLineDataApi;
exports.getProductShippingPieDataApi = getProductShippingPieDataApi;
exports.getProductStatisticsDataApi = getProductStatisticsDataApi;
exports.getProductTypePieDataApi = getProductTypePieDataApi;
exports.getUserStatisticsDataApi = getUserStatisticsDataApi;
exports.pageviewDataApi = pageviewDataApi;
exports.payDataApi = payDataApi;
exports.viewModelApi = viewModelApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

// 首页数据概览
function viewModelApi() {
  return (0, _request.default)({
    url: '/admin/merchant/statistics/home/index',
    method: 'GET'
  });
}

// 用户曲线图
function chartUserApi() {
  return (0, _request.default)({
    url: '/admin/statistics/home/chart/user',
    method: 'get'
  });
}

// 用户购买统计
function chartBuyApi() {
  return (0, _request.default)({
    url: '/admin/statistics/home/chart/user/buy',
    method: 'get'
  });
}

// 订单量趋势 30天
function chartOrder30Api() {
  return (0, _request.default)({
    url: '/admin/statistics/home/chart/order',
    method: 'get'
  });
}

// 订单量趋势 月
function chartOrderMonthApi() {
  return (0, _request.default)({
    url: '/admin/statistics/home/chart/order/month',
    method: 'get'
  });
}

// 订单量趋势 周
function chartOrderWeekApi() {
  return (0, _request.default)({
    url: '/admin/statistics/home/chart/order/week',
    method: 'get'
  });
}

// 订单量趋势 年
function chartOrderYearApi() {
  return (0, _request.default)({
    url: '/admin/statistics/home/chart/order/year',
    method: 'get'
  });
}

// 首页经营数据
function businessData() {
  return (0, _request.default)({
    url: '/admin/merchant/statistics/home/operating/data',
    method: 'get'
  });
}

// 商品浏览量排行榜
function pageviewDataApi() {
  return (0, _request.default)({
    url: '/admin/merchant/statistics/home/product/pageview/ranking',
    method: 'get'
  });
}

// 商品支付排行榜
function payDataApi() {
  return (0, _request.default)({
    url: '/admin/merchant/statistics/home/product/pay/ranking',
    method: 'get'
  });
}

// 商品收藏量排行榜
function collectDataApi() {
  return (0, _request.default)({
    url: '/admin/merchant/statistics/home/product/collect/ranking',
    method: 'get'
  });
}

// ==================== 商品统计 API ====================

// 商品统计顶部核心数据
function getProductStatisticsDataApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/product/statistics/top',
    method: 'get',
    params: params
  });
}

// 商品折线图数据
function getProductLineDataApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/product/statistics/chart',
    method: 'get',
    params: params
  });
}

// 商品分类饼图数据
function getProductCategoryPieDataApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/product/statistics/category',
    method: 'get',
    params: params
  });
}

// 商品类型饼图数据
function getProductTypePieDataApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/product/statistics/type',
    method: 'get',
    params: params
  });
}

// ==================== 订单统计 API ====================

// 订单统计顶部核心数据
function getOrderStatisticsDataApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/order/statistics/top',
    method: 'get',
    params: params
  });
}

// 订单折线图数据
function getOrderLineDataApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/order/statistics/chart',
    method: 'get',
    params: params
  });
}

// 订单类型饼图数据
function getOrderTypePieDataApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/order/statistics/type',
    method: 'get',
    params: params
  });
}

// 订单发货饼图数据
function getProductShippingPieDataApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/order/statistics/shipping',
    method: 'get',
    params: params
  });
}

// ==================== 用户统计 API ====================

// 用户统计顶部核心数据
function getUserStatisticsDataApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/user/statistics/top',
    method: 'get',
    params: params
  });
}

// 新增用户数据
function getNewUserDataApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/user/statistics/add',
    method: 'get',
    params: params
  });
}

// 活跃用户数据
function getActiveUserDataApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/user/statistics/alive',
    method: 'get',
    params: params
  });
}

// 成交用户数据
function getBoughtUserDataApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/user/statistics/bought',
    method: 'get',
    params: params
  });
}

// 新增商户会员数据
function getNewMemberDataApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/user/statistics/member',
    method: 'get',
    params: params
  });
}